import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksCounterpartyCreationPopupContent', {
    acctNum: 'Account no.',
    acctNumPlaceholder: `Enter account's name or number`,
    addressHeader: 'Address',
    billingAddressHeader: 'Billing address',
    shippingAddressHeader: 'Shipping address',
    contactInformationHeader: '{counterparty} Information',
    displayNameLengthErrorText: 'Display name cannot exceed {length} characters.',
    doneButtonText: 'Create',
    doneButtonTitle: 'Create {counterparty}',
    invalidDisplayNameErrorText: 'Display name cannot contain the following symbols: ":", "<", ">", "&#"',
    noEmojiInContactName: 'Emojis are not allowed in Display name',
    popupTitle: 'New {counterparty}',
    sameAsBillingAddress: 'Same as billing address',
    vendor: 'Vendor',
    customer: 'Customer',
    invalidWebsite: 'Website URL is invalid',
    invalidPhone: 'Phone number can contain only digits and the following symbols: "-", ".", ",", "+", "(", ")".',
    invalidMobile: 'Mobile number can contain only digits and the following symbols: "-", ".", ",", "+", "(", ")".',
    invalidFax: 'Fax number can contain only digits and the following symbols: "-", ".", ",", "+", "(", ")".',
    phoneLengthErrorText: 'Phone number cannot exceed {length} characters.',
    mobileLengthErrorText: 'Mobile number cannot exceed {length} characters.',
    faxNameLengthErrorText: 'Fax number cannot exceed {length} characters.',
    requiredDisplayName: 'Display name is required',
});
